import {
  NAME_AND_CITY_NOT_ALLOWED_SYMBOLS,
  mustNotContainNumber,
  mustNotContainSymbols,
  noWhiteStartOrEnd,
  required
} from '@ps/web-shared-validators';
import React from 'react';
import { useField } from 'react-final-form';

import TextInput from '../../../../../TextInput/TextInput';

import {
  TXTWCL_Birth_name,
  TXTWCL_The_name_you_have_entered_is_i_ELL
} from './BirthName.messages.json';

const BirthName: React.FC = () => {
  const {
    input: { value }
  } = useField('birthName');

  return (
    <TextInput
      id="birthName"
      label={TXTWCL_Birth_name}
      value={value}
      maxLength={50}
      checkDisabled
      validators={[
        required(),
        noWhiteStartOrEnd,
        mustNotContainNumber(TXTWCL_The_name_you_have_entered_is_i_ELL, true),
        mustNotContainSymbols(
          NAME_AND_CITY_NOT_ALLOWED_SYMBOLS,
          TXTWCL_The_name_you_have_entered_is_i_ELL
        )
      ]}
    />
  );
};

export default BirthName;
